import { EntityModel } from './../../model';
import { Injectable, OnDestroy, Optional } from '@angular/core';
import { MouseCanvasService, Ng3MosueWheelEvent } from './mouse-canvas.service';
import { EntityService } from '../../components/entity.service';
import { Observable, Subject, noop, merge } from 'rxjs';
import { OrthographicCamera, Vector3, Vector2 } from 'three';
import {
  map,
  filter,
  takeUntil,
  switchMap,
  distinctUntilChanged,
} from 'rxjs/operators';
import { EntityComponent } from '../../components/share/entity-component';

// TODO: fix setCamera, or better implementation without need of setCamera
export interface EntityDragEvent {
  origin: Vector2;
  relativeCenter: Vector2;
  current: Vector2;

}

@Injectable()
export class MouseEntityService implements OnDestroy {
  private stop = new Subject<void>();
  private camera: OrthographicCamera | undefined;
  private cameraDirection = new Vector3();
  readonly down$ = this.createDown$();
  readonly click$ = this.createClick$();
  readonly drag$ = this.createDrag$();
  readonly hover$ = this.mouseCanvas.position$.pipe(
    map(p => this.isOnThisEntity(p)),
    distinctUntilChanged(),
    takeUntil(this.stop),
  );
  readonly wheel$ = this.createWheel$();
  constructor(
    private mouseCanvas: MouseCanvasService,
    // private entityService: EntityService,
    @Optional() private entity2: EntityComponent<EntityModel>
  ) {}
  private createClick$(): Observable<void> {
    return this.down$.pipe(
      switchMap(() => {
        return merge(this.mouseCanvas.up$, this.mouseCanvas.leave$).pipe(
          map(u => {
            if (this.isOnThisEntity(u)) {
              return true;
            } else {
              return false;
            }
          }),
        );
      }),
      filter(x => !!x),
      map(noop),
    );
  }
  private createDown$(): Observable<Vector2> {
    return this.mouseCanvas.down$.pipe(
      filter(p => this.isOnThisEntity(p)),
      takeUntil(this.stop),
    );
  }

  private createWheel$(): Observable<Ng3MosueWheelEvent> {
    return this.mouseCanvas.wheel$.pipe(
      filter(e => this.isOnThisEntity(e.position)),
      takeUntil(this.stop),
    );
  }

  private isOnThisEntity(p: Vector2) {
    // if (this.entityService.entity === undefined) {
    //   return false;
    // }
    if (this.entity2.entity === undefined) {
      return false;
    }
    let direction: Vector3;
    if (this.camera === undefined) {
      direction = new Vector3(0, 0, -1);
    } else {
      this.camera.getWorldDirection(this.cameraDirection);
      direction = this.cameraDirection;
    }
    const intersects = this.mouseCanvas.intersectObject(
      new Vector3(p.x, p.y, 100),
      direction,
    );
    if (intersects.length === 0) {
      return false;
    }
    const firstIntersect = intersects[0];
    // if (firstIntersect.object.uuid !== this.entityService.entity.uuid) {
    //   return false;
    // }
    if (firstIntersect.object.uuid !== this.entity2.entity.uuid) {
      return false;
    }
    return true;
  }

  private createDrag$(): Observable<EntityDragEvent> {
    const cancel = merge(this.mouseCanvas.up$, this.mouseCanvas.leave$);
    return this.down$.pipe(
      switchMap(origin => {
        const center =
          // this.entityService.entity === undefined
          //   ? new Vector2(0, 0)
          //   : new Vector2(
          //       this.entityService.entity.position.x,
          //       this.entityService.entity.position.y,
          //     );
          this.entity2.entity === undefined
            ? new Vector2(0, 0)
            : new Vector2(
                this.entity2.entity.position.x,
                this.entity2.entity.position.y,
              );
        const offset = new Vector2(origin.x - center.x, origin.y - center.y);
        return this.mouseCanvas.position$.pipe(
          map(current => {
            return {
              origin,
              current,
              relativeCenter: new Vector2(
                current.x - offset.x,
                current.y - offset.y,
              ),
            };
          }),
          takeUntil(cancel),
        );
      }),
      takeUntil(this.stop),
    );
  }

  ngOnDestroy() {
    this.stop.next();
    this.stop.complete();
  }
  setCamera(camera: OrthographicCamera) {
    this.camera = camera;
  }
}


